import Rollbar from "rollbar";

export const rollbarClientConfig = {
    accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.NODE_ENV,
};

let rollbarInstance: Rollbar | null = null;

export function getRollbar(): Rollbar {
    if (!rollbarInstance) {
      rollbarInstance = new Rollbar(rollbarClientConfig);
    }
    return rollbarInstance;
}

export function tryPushRollbarError(error: Error, context: any) {
    try {
        getRollbar().error(error, context);
    } catch (error) {
        console.error('Failed to push error to Rollbar:', error);
    }
}